import stls from '@f_ucs/styles/components/report/violationStatisticsModule/purchaseReport/reportTable/reportTable.module.sass';
import { useContext } from 'react';
import { ThemeContext } from '@f_context/Theme_context';

export function ColumnWarehouse ({ index, warehouse }: any, idRow:any, isOpenDetails:any)  {
    const { colors } = useContext(ThemeContext);

    return (
        <div
            className={stls.cell}
            style={{
                color:
                    idRow !== index && isOpenDetails ? colors.blurColor : colors.omicron,
            }}>
            {warehouse}
        </div>
    )
}